import Carousel from './components/Carousel.js';
import Checklist from './components/Checklist.js';
import Scrolly from './components/Scrolly.js';
import Accordion from './components/Accordion.js';
import Tabs from './components/Tabs.js';
import Header from './components/Header.js';
import Panel from './components/Panel.js';

export default class ComponentFactory {
  constructor() {
    this.componentInstances = [];
    this.componentList = {
      Accordion,
      Carousel,
      Header,
      Checklist,
      Panel,
      Scrolly,
      Tabs,
    };
    this.init();
  }

  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
        this.componentInstances.push(instance);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
